import { Link } from 'react-router-dom'
import { Clock } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export function SessionExpiredPage() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-center text-2xl">Session expired</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-center">
        <Clock className="mx-auto size-10 text-warning" />
        <p className="text-sm text-muted-foreground">
          For your security we ended your session. Please sign in again to continue.
        </p>
        <Button asChild className="w-full">
          <Link to="/login">Back to sign in</Link>
        </Button>
      </CardContent>
    </Card>
  )
}
